import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'
import FileDownload from 'js-file-download'
import moment from 'moment'
import axios from 'axios'
import { MERCHANTS_DISTRIBUTION_URL, MERCHANTS_DISTRIBUTION_TOKEN } from '../env.js'
import { level2LocationDetails, level3LocationDetails } from '../config/manhthdConfigs'
import { Get, getUrl, Post } from '@/services/customer-support'

export class MerchantService extends BaseService {
  static async uploadVerifyImages(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.verify-bank-account'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDataMerchantLeadId(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.get-device-serials-by-lead-id'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDataMerchantByCustomerId(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.get-device-serials-by-customer-id'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // danh sách mc
  static async getDataMerchant(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDataMerchantPotential(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-get-list-potential'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async fetchMerchantBusiness(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.need-business-reg-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportMerchantbusiness(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.business-reg-get-excel'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Export_businessMerchant' +
          '_' +
          moment(new Date(new Date())).format('DD/MM/YYYY') +
          '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getMposMid(customerId) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.get-mpos-mid'),
        { customerId }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getNoMerchants(params) {
    try {
      const response = await this.request({ auth: true }).post(MERCHANTS_DISTRIBUTION_URL, params)
      return response.data.data
    } catch (error) {
      return []
    }
  }

  static async mockingMerchants(params) {
    try {
      const controllingLocationCodes = params.controllingLocationCodes.split(',')
      const allLocations =
        params.locationLevel.toString() === '2' ? level2LocationDetails : level3LocationDetails

      const locations = allLocations.filter(elem =>
        controllingLocationCodes.some(controlCode => elem.code.startsWith(controlCode))
      )
      const mockingResponse = await Promise.resolve(
        locations.map(elem => {
          const noMerchantsPerDegree = 1000
          const noDegrees = 12
          const noMerchants = Math.round(Math.random() * noMerchantsPerDegree * noDegrees)
          return {
            adminLocationCode: elem.code,
            adminLocationName: elem.name,
            count: noMerchants,
          }
        })
      )
      return mockingResponse
    } catch (error) {
      return []
    }
  }

  // xuất excel danh sách mc
  static async exportMerchant(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-get-excel'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Report-list-merchant' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportMposMid(customerId) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.export-mpos-mid'),
        { customerId },
        {
          responseType: 'blob',
        }
      )
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // chi tiết mc
  static async merchantDetail(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-get-info-by-id'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // link hợp đồng trong chi tiết mc
  static async contractInfo(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.list-contract-approved-by-customer'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // thêm mới mc
  static async insertMerchant(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-register'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // edit mc
  static async updateMerchant(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-update-on-web'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // xuất excel báo cáo mc
  static async export(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-list-export'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Report-merchant' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // danh sách mc điều chuyển
  static async getlistMCTrans(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-get-list-transfer'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // điều chuyển mc
  static async transferMC(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.pre-transfer'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // lịch sử điều chuyển mc
  static async historyTrans(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.transfer-history-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // chi tiết lịch sử điều chuyển mc
  static async historyTransDetail(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.transfer-history-detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // hủy lệnh điều chuyển mc
  static async cancelTransfer(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.cancel-transfer'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // nhận lệnh điều chuyển
  static async receiveTransfer(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.receive-transfer'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // từ chối lệnh điều chuyển
  static async refuseTransfer(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.refuse-transfer'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateById(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.customer-update-by-id'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // báo cáo mc nextlend
  static async nextlendMCReport(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.nextlend-mc-report'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // xuất excel list mc nextlend báo cáo
  static async exportMerchantNextlend(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.nextlend-mc-export'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Report-list-merchant' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // chi tiết báo cáo mc nextlend
  static async nextlendMCReportDetail(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.nextlend-mc-report-detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // xuất excel chi tiết mc nextlend báo cáo
  static async exportMerchantNextlendDetail(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.nextlend-mc-xls-detail'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Report-list-merchant' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async listMCLanding(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.landing-undefined-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportMCLanding(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.landing-undefined-list-xls'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'List_Merchant_Landing' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateStatusMC(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.sales-process-list-update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async addProfileAFSale(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldras.copy'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async addProfileSale(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.wkcldr.copy'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async listLocMcId(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.get-all-loc-mc-id'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async listDeviceLocation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createDeviceLocation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-create'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateDeviceInfoLocation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-device-update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateMerchantInfoLocation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-mc-update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateMerchantAreaLocation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-area-update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async verifyDeviceLocation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-verify'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async lockDeviceLocation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-change-lock'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailDeviceLocation(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-detail-by-id'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async historyDeviceLocation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-history'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailHistoryDeviceLocation(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.loc-serial-history-detail'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateSource(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.source-update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getPlaneServiceCommbo(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.get-plan-config'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createOrUpdateMerchant(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.econtract-update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createComboContract(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.paper.save-sell-contract-web'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async uploadContactImage(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.save-mix-files'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createNewMerchant(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.econtract-register'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getHistoryKyc(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.360.get-history-kyc'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async confirmKycMc(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cstm.360.confirm-kyc-mc'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}

export const getListProposalFee = async body => {
  return Post(getUrl('cnps.scon.proposal-fee.get-list'), body)
}

export const getDetailProposalFee = async id => {
  return Get(getUrl('cnps.scon.proposal-fee.detail', { id }))
}

export const getConfigProposalFee = async () => {
  return Get(getUrl('cnps.scon.proposal-fee.map-config'))
}
